import { render, staticRenderFns } from "./adminRoomFeeList.vue?vue&type=template&id=287bd9e8&scoped=true"
import script from "./adminRoomFeeList.vue?vue&type=script&lang=js"
export * from "./adminRoomFeeList.vue?vue&type=script&lang=js"
import style0 from "./adminRoomFeeList.vue?vue&type=style&index=0&id=287bd9e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287bd9e8",
  null
  
)

export default component.exports